import "../../components/Tools/typdefs";

const state = {
  /** @type {StoredFlags} */
  SurveyFlags: {
    redirectCache: false,
  },
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
const getters = {};

/** @type {import("vuex").ActionTree<typeof state>} */
const actions = {
  toogleCache({ commit, state }, id) {
    let key = id.toString();
    if (state.SurveyFlags[key] && state.SurveyFlags[key].offlineCache) {
      commit("destroyCache", id);
      commit("dectivateRedirectCache");
    } else {
      commit("buildCache", id);
    }
  },
  flushCacheFor({ commit }, { flushoffline, id }) {
    let key = id.toString();
    if (flushoffline) {
      commit("flushoffline", key);
    }
    commit("flushUnsavechanges", key);
  },
};

/** @type {import("vuex").MutationTree<typeof state>} */
const mutations = {
  flushoffline(state, key) {
    state.SurveyFlags[key].offlineCache = false;
  },
  flushUnsavechanges(state, key) {
    state.SurveyFlags[key].unsavedChanges = false;
  },
  dectivateRedirectCache(state) {
    state.SurveyFlags.redirectCache = false;
  },
  flushCachefor(state, key) {
    state.SurveyFlags[key].offlineCache = false;
    state.SurveyFlags[key].unsavedChanges = false;
  },
  initializeFlags(state, id) {
    let key = id.toString();
    if (!state.SurveyFlags[key]) {
      state.SurveyFlags[key] = {};
      state.SurveyFlags[key].unsavedChanges = false;
      state.SurveyFlags[key].offlineCache = false;
    }
  },
  buildCache(state, id) {
    let key = id.toString();
    state.SurveyFlags[key].offlineCache = true;
  },
  unsavedChanges(state, id) {
    let key = id.toString();
    state.SurveyFlags[key].unsavedChanges = true;
  },
  flushCache(state, { offline, id }) {
    let key = id.toString();
    if (!offline) {
      state.SurveyFlags[key].offlineCache = false;
    }
    state.SurveyFlags[key].unsavedChanges = false;
  },
  destroyCache(state, id) {
    let key = id.toString();
    state.SurveyFlags[key].offlineCache = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/surveyjs/store/modules/cacheStore.js